<template>
  <a-modal :visible="showDialog"  :mask="true" :maskClosable="false" title="编辑" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="vertical">
     <a-form-item label="部门">
       <a-input v-model="dataInfo.name" placeholder="部门" />
     </a-form-item>
     <a-form-item label="department_id">
       <a-input v-model="dataInfo.department_id" placeholder="department_id" disabled />
     </a-form-item>
     <a-form-item label="open_department_id">
       <a-input v-model="dataInfo.open_department_id" placeholder="open_department_id" disabled/>
     </a-form-item>
     <a-form-item label="用户组">
        <a-select v-model="dataInfo.group_id" allowClear :maxTagCount="1" placeholder="请选择用户组"
          optionFilterProp="label" show-search>
          <a-select-option v-for="groupItem in groupList" :label="groupItem.real_name" :value="groupItem.id"
            :key="groupItem.id">
            {{ groupItem.real_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
   </a-form>
  </a-modal>
</template>
<script>
import {RelationSave} from "../../api/v1/group_api";

export default {
  name: "RelationEditDialog",
  props:['dataInfo','showDialog','groupList'],
  data(){
    return {
    }
  },
  methods:{
    handleOk(){
      let data = {
        "id":this.dataInfo.id,
        "name":this.dataInfo.name,
        "department_id":this.dataInfo.department_id,
        "open_department_id":this.dataInfo.open_department_id,
        "group_id":this.dataInfo.group_id,
      }

      RelationSave(data).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/relationEditDialog.vue